import * as React from 'react';
import { inject } from 'mobx-react';

import { AdvertisingStore } from 'stores/advertising-store';

interface MesoTriggerProps {
  advertising?: AdvertisingStore;
  pageName: string;
}

@inject('advertising')
export class MesoTrigger extends React.Component<MesoTriggerProps> {
  public componentDidMount() {
    this.props.advertising.trigger(this.props.pageName);
  }

  public render() {
    return null;
  }
}
